module.exports = __webpack_public_path__ + "img/partner2.5b2b313d.png";